
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/[query]",
      function () {
        return require("private-next-pages/search/[query].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/[query]"])
      });
    }
  